/** Whether the records table action toolbar should render for the current selection. */
export const getShowActionToolbar = ({
  externalActionToolbarSelectedRowCount,
  hasRowLevelActions,
  pageSelectedRowCount,
}: {
  externalActionToolbarSelectedRowCount?: number
  hasRowLevelActions: boolean
  pageSelectedRowCount: number
}) => {
  if (!hasRowLevelActions) {
    return false
  }
  if (externalActionToolbarSelectedRowCount != null) {
    return externalActionToolbarSelectedRowCount > 0
  }
  return pageSelectedRowCount > 0
}
